import React, { Component } from "react";
import "./App.css";

import Login    from "./pages/Login";
import Sidebar  from "./components/Sidebar";
import Header   from "./components/Header";

import Home      from "./pages/Home";
import AboutUs   from "./pages/AboutUs";
import Services  from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Clients   from "./pages/Clients";
import Team      from "./pages/Team";
import Contact   from "./pages/Contact";
import Blog   from "./pages/blog";
import Setting   from "./pages/Setting";

const ROUTES = {
  "#home"      : "Home",
  "#about"     : "About Us",
  "#services"  : "Services",
   "#blog"      : "Blog",
  "#portfolio" : "Portfolio",
  "#clients"   : "Clients",
  "#team"      : "Team",
  "#contact"   : "Contact",
  "#setting"   : "Setting",
};

const PAGE_TO_HASH = {
  "Home"      : "#home",
  "About Us"  : "#about",
  "Services"  : "#services",
  "Blog"   : "#blog",
  "Portfolio" : "#portfolio",
  "Clients"   : "#clients",
  "Team"      : "#team",
  "Contact"   : "#contact",
   "Setting"   : "#setting",
};

function getPageFromHash() {
  const hash = window.location.hash;
  return ROUTES[hash] || "Home";
}

class App extends Component {
  constructor(props) {
    super(props);
    const token = localStorage.getItem("adminToken");
    this.state = {
      isLoggedIn   : !!token,
      activePage   : getPageFromHash(),
      sidebarOpen  : false, // ✅ Mobile sidebar toggle
    };
  }

  componentDidMount() {
    // Sync URL on first load
    const { isLoggedIn, activePage } = this.state;
    if (isLoggedIn) {
      const hash = PAGE_TO_HASH[activePage];
      if (hash && window.location.hash !== hash) {
        window.location.hash = hash;
      }
    }
    window.addEventListener("hashchange", this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.handleHashChange);
  }

  handleHashChange = () => {
    if (this.state.isLoggedIn) {
      this.setState({ activePage: getPageFromHash(), sidebarOpen: false });
    }
  };

  handleLogin = () => {
    const page = getPageFromHash();
    const hash = PAGE_TO_HASH[page] || "#home";
    window.location.hash = hash;
    this.setState({ isLoggedIn: true, activePage: page });
  };

  handleNavigate = (page) => {
    if (page === "Logout") {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUser");
      window.location.hash = "";
      this.setState({ isLoggedIn: false, activePage: "Home", sidebarOpen: false });
      return;
    }
    const hash = PAGE_TO_HASH[page] || "#home";
    window.location.hash = hash;
    this.setState({ activePage: page, sidebarOpen: false }); // ✅ Close sidebar after nav on mobile
  };

  // ✅ Toggle mobile sidebar
  toggleSidebar = () => {
    this.setState((prev) => ({ sidebarOpen: !prev.sidebarOpen }));
  };

  closeSidebar = () => {
    this.setState({ sidebarOpen: false });
  };

  renderPage() {
    switch (this.state.activePage) {
      case "Home"      : return <Home />;
      case "About Us"  : return <AboutUs />;
      case "Services"  : return <Services />;
      case "Portfolio" : return <Portfolio />;
      case "Clients"   : return <Clients />;
      case "Team"      : return <Team />;
      case "Contact"   : return <Contact />;
      case "Blog"   : return <Blog />;
       case "Setting"   : return <Setting />;
      default          : return <Home />;
    }
  }

  render() {
    const { isLoggedIn, activePage, sidebarOpen } = this.state;

    if (!isLoggedIn) {
      return <Login onLogin={this.handleLogin} />;
    }

    return (
      <div className="app-container">
        <Sidebar
          activePage={activePage}
          onNavigate={this.handleNavigate}
          isOpen={sidebarOpen}
          onClose={this.closeSidebar}
        />

        {/* ✅ Backdrop overlay for mobile when sidebar is open */}
        {sidebarOpen && <div className="sidebar-backdrop" onClick={this.closeSidebar} />}

        <div className="main-area">
          <Header activePage={activePage} onMenuClick={this.toggleSidebar} />
          <div className="page-content">
            {this.renderPage()}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
